import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Award from "./Award";
import biosphereLogo from "../../assets/images/awards/biosphere-logo.png";
import biospherePopup from "../../assets/images/awards/Biosphere_verde.png";
import cifftLogo from "../../assets/images/awards/CIFFT.png";
import ondaCeroLogo from "../../assets/images/awards/Onda_Cero.png";

function Awards({ transparent = true }) {
  const [container] = useState(() => {
    // This will be executed only on the initial render
    // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    // create div to be added to the footer and receive the Awards component
    const element = document.createElement("div");
    return element;
  });

  useEffect(() => {
    // add container to the footer, as first child
    const footer = document.getElementById("footer");
    const footerChild = document.getElementsByClassName(
      "main-footer-container"
    )[0];
    footer?.insertBefore(container, footerChild);
  }, []);

  return ReactDOM.createPortal(
    <div
      id="awards"
      className="ahp-awards"
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "30px",
        height: "300px",
        width: "100%",
        color: "white",
        padding: "200px 0px 20px 0",
      }}
    >
      <Award
        title="Biosphere"
        description="Biosphere Certified Destination"
        link="https://www.biospheretourism.com/en/entity/aldeias-historicas-de-portugal/528"
        imgSrcPopup={biospherePopup}
        imgSrc={biosphereLogo}
        width={50}
      />
      <Award
        title="CIFFT"
        description="World's Best Tourist Film"
        imgSrc={cifftLogo}
        // this is a rectangular logo, the height is set with the same size as the other logos' width for a perfect alignement
        height={50}
        divWidth={150}
        link="https://aldeiashistoricasdeportugal.com/en/aldeias-historicas-de-portugal-vencem-melhor-filme-de-turismo-do-mundo/"
      />
      <Award
        title="Onda Cero"
        description="Prémio de melhor destino português"
        imgSrc={ondaCeroLogo}
        width={50}
        link="https://aldeiashistoricasdeportugal.com/en/aldeias-historicas-de-portugal-premiadas-em-espanha-como-o-melhor-destino-portugues/"
      />
      {/* <Award
        title="Prémio 4"
        description="Prémio 4 atribuído às Aldeias Históricas de Portugal"
        link=""
      /> */}
    </div>,
    container
  );
}

export default Awards;
